var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9375 8.66656L51.3333 18.0624C51.7292 18.4582 51.7292 19.1041 51.3333 19.4999L28.5833 42.2499L18.9167 43.3228C17.625 43.4686 16.5312 42.3749 16.6771 41.0832L17.75 31.4165L40.5 8.66656C40.8958 8.27073 41.5417 8.27073 41.9375 8.66656ZM58.8125 6.28114L53.7292 1.19781C52.1458 -0.385518 49.5729 -0.385518 47.9792 1.19781L44.2917 4.88531C43.8958 5.28115 43.8958 5.92698 44.2917 6.32281L53.6875 15.7186C54.0833 16.1145 54.7292 16.1145 55.125 15.7186L58.8125 12.0311C60.3958 10.4374 60.3958 7.86448 58.8125 6.28114ZM40 36.0624V46.6665H6.66667V13.3332H30.6042C30.9375 13.3332 31.25 13.1978 31.4896 12.9686L35.6562 8.80198C36.4479 8.01031 35.8854 6.66656 34.7708 6.66656H5C2.23958 6.66656 0 8.90614 0 11.6666V48.3332C0 51.0936 2.23958 53.3332 5 53.3332H41.6667C44.4271 53.3332 46.6667 51.0936 46.6667 48.3332V31.8957C46.6667 30.7811 45.3229 30.229 44.5312 31.0103L40.3646 35.177C40.1354 35.4165 40 35.729 40 36.0624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.ad2033db24ab1cd7db8720609b6ddaf9.svg";
export { ForwardRef as ReactComponent };